import Vue from 'vue'
import App from './App.vue'
import './static/css/reset.css';
import './static/css/sspai.css';
import './static/css/normalize.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from '@/router'
import store from '@/store'
import './permission'
import { resourceUrl } from '@/utils/request'

Vue.prototype.resourceUrl = resourceUrl;

Vue.config.productionTip = false
Vue.use(ElementUI);


new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app');
